var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"border-0 h-100 w-100",attrs:{"srcdoc":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }